module.exports = __webpack_public_path__ + "startpage-746fed5a/step3-dcdc79e40ed82c4a20928fd8d88948c6.svg";